import request from '../fetch/index'

// 获取消息列表
export function getMessageList({ pageNo, pageSize }) {
  return request({
    url: '/api/loan/user/message/app',
    method: 'GET',
    params: {
      pageNo,
      pageSize
    }
  })
}

// 读取消息
export function readMessage({ id }) {
  return request({
    url: `/api/loan/user/message/app/read/${id}`,
    method: 'POST'
  })
}

// 查询是否有未读消息
export function hasUnReadMessage() {
  return request({
    url: `/api/loan/user/message/app/unread`,
    method: 'GET'
  })
}

/**
 * 首页公告提示
 * @param {tipCode} - NET_GO_ONLINE_TIP | NEW_YEAR_TIP
 */
export function homeMessageTips({ tipCode = 'NET_GO_ONLINE_TIP' } = {}) {
  return request({
    url: `/api/loan/tips/selectTip`,
    method: 'POST',
    params: {
      tipCode
    }
  })
}
